import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import ResidentStatusListings from '../components/listings/ResidentStatusListings';
import DraggableProfilePanel from '../components/common/DraggableProfilePanel';

function ResidentStatusListingPage() {
    return (
        <>
        <div className="parent-container">
            <div className="container">
            <div className="header-class">
            <Header isVisible={true} buttonsVisible={true}/>
            </div>
                <div className="content-class">
                    <DraggableProfilePanel/>
                    <ResidentStatusListings />
                </div>
                <div className="footer-class">
                    <Footer />
                </div>
            </div>
      </div>
        </>
    );
}

export default ResidentStatusListingPage;